// apps/web/src/components/landing-v2/proofs/VoicesProof.tsx
import { useState } from 'react'

/** Theme 04 / More than one deck — segmented switcher by DECK (not by person).
 *  Each deck shows one of its OWN card teachings, so nothing is cross-attributed.
 *  Visual mock for the marketing surface. Reference: handoff .mm-voices. */

const DECKS = ['The Cosmic Finder', 'Breath of Gold', '+ more'] as const

const READINGS: Record<(typeof DECKS)[number], { card: string; text: string; by: string }> = {
  'The Cosmic Finder': {
    card: 'The Star · Upright',
    text:
      'Trust the slow rebuild. The Star is patient — light returning, not arriving all at once.',
    by: 'oracle & astrology',
  },
  'Breath of Gold': {
    card: 'Breathe in Courage',
    text:
      'Breathe with the wait — what arrives when you let the body settle first.',
    by: 'breath & somatic',
  },
  '+ more': {
    card: 'More on the way',
    text:
      'New decks join the shelf over time — each with its own card teachings.',
    by: 'coming soon',
  },
}

export function VoicesProof() {
  const [active, setActive] = useState<(typeof DECKS)[number]>('The Cosmic Finder')
  const reading = READINGS[active]

  return (
    <div className="absolute inset-0 flex flex-col p-[18px]">
      <span className="inline-flex w-fit items-center rounded-pill border border-gold-light-legacy/30 bg-gold-light-legacy/[0.14] px-2.5 py-1 text-[10px] font-medium uppercase tracking-[0.14em] text-gold-light-legacy">
        {reading.card}
      </span>

      <div
        className="mt-2 flex w-fit flex-wrap gap-1 rounded-pill border p-[3px]"
        style={{
          background: 'var(--hairline-faint)',
          borderColor: 'var(--hairline)',
        }}
        role="tablist"
        aria-label="Choose a deck"
      >
        {DECKS.map((t) => {
          const isActive = t === active
          return (
            <button
              key={t}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => setActive(t)}
              className={`rounded-pill px-2.5 py-1 text-[9px] font-medium uppercase tracking-[0.14em] transition-colors ${
                isActive ? 'text-accent-contrast' : 'text-text-muted hover:text-text-secondary'
              }`}
              style={
                isActive
                  ? { background: 'var(--color-astral-violet)' }
                  : undefined
              }
            >
              {t}
            </button>
          )
        })}
      </div>

      <div
        className="mt-2.5 rounded-r-lg border-l-2 px-3 py-3 font-display text-text-primary"
        style={{
          borderColor: 'color-mix(in oklab, var(--color-astral-violet) 50%, transparent)',
          background: 'color-mix(in oklab, var(--color-astral-violet) 5%, transparent)',
          fontSize: '0.78rem',
          lineHeight: 1.45,
        }}
      >
        {reading.text}
      </div>
      <div
        className="mt-1.5 text-[10px] uppercase text-text-muted"
        style={{ letterSpacing: '0.18em' }}
      >
        {active === '+ more' ? (
          reading.by
        ) : (
          <>
            <em className="not-italic text-astral-violet-light">{active}</em> · {reading.by}
          </>
        )}
      </div>
    </div>
  )
}
